export const DEFAULT_ACTION_ITEM_WIDTH = 40;

export const PLACEHOLDER = <>&ndash;</>;

export const ROW_HEIGHT = 36;

export const MOBILE_ROW_HEIGHT = 44;
